import { Card, CardBody, Col, Container, Row } from 'reactstrap'
import StaffRegisterForm from '../../../../Componant/Application/Project/master/StaffRegisterForm'


const StaffForm = () => {
  return (
    <Container fluid>
      <Row>
        <Col sm="12">
          <Card>
            <CardBody>
              <StaffRegisterForm />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  )
}

export default StaffForm